export default __webpack_public_path__ + "static/media/sliderInactive.ab1a766d.svg";